import { useEffect, useRef, useState } from "react";
import { ArrowsClockwise } from "@phosphor-icons/react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function UpdateBanner() {
  const initialVersion = useRef(null);
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const res = await fetch(`${API}/api/health`, { cache: "no-store" });
        const data = await res.json();
        if (cancelled || !data.version) return;
        if (initialVersion.current === null) {
          initialVersion.current = data.version;
        } else if (data.version !== initialVersion.current) {
          setUpdateAvailable(true);
        }
      } catch {
        /* offline — silencioso */
      }
    };
    check();
    const interval = setInterval(check, 60000);
    const onVisible = () => document.visibilityState === "visible" && check();
    document.addEventListener("visibilitychange", onVisible);
    return () => { cancelled = true; clearInterval(interval); document.removeEventListener("visibilitychange", onVisible); };
  }, []);

  const handleUpdate = async () => {
    setReloading(true);
    try {
      if ("caches" in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
      if ("serviceWorker" in navigator) {
        const reg = await navigator.serviceWorker.getRegistration();
        if (reg) await reg.update();
      }
    } catch { /* segue para reload */ }
    window.location.reload();
  };

  if (!updateAvailable) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] flex justify-center px-3 pt-3 pointer-events-none">
      <button
        onClick={handleUpdate}
        disabled={reloading}
        data-testid="update-banner"
        className="pointer-events-auto flex items-center gap-2.5 bg-zinc-950 text-white pl-4 pr-5 py-3 min-h-[44px] rounded-full shadow-2xl border border-zinc-700 text-sm font-semibold hover:bg-zinc-800 transition-colors animate-in slide-in-from-top duration-300"
      >
        <ArrowsClockwise size={18} weight="bold" className={reloading ? "animate-spin" : ""} />
        {reloading ? "Atualizando..." : "Nova versão disponível — toque para atualizar"}
      </button>
    </div>
  );
}
